import { useFeatureFlagVariant } from "@/utils/kameleoon/useFeatureFlagVariant";
export function useIsSavedSearchEnabled() {
    const savedSearchEnabledVariant = "b";
    const isSavedSearchEnabled = useFeatureFlagVariant("cdp_saved_search_opt_in", savedSearchEnabledVariant);
    return isSavedSearchEnabled;
}
